import React from "react";
import { useOnlineStatus } from "./hooks";

export function OnlineStatus() {
  const isOnline = useOnlineStatus();
  const text = isOnline ? "Online" : "Offline";
  const color = isOnline ? "darkgreen" : "lightgrey";
  return <div style={{ color }}>{text}</div>;
}
